import { FormControlLabel, Select, styled } from '@mui/material';
import { COLORS } from '../../../theme/color';

export const StyledInput = styled('input')<{
  icon?: any;
}>(({ icon }) => ({
  outline: 'none',
  border: 'none',
  borderRadius: '12px 0 0 12px',
  color: '#483D3D',
  width: '100%',
  padding: '1rem',
  fontSize: '16px',
  fontWeight: '400',
  '&::-webkit-outer-spin-button': {
    '-webkit-appearance': 'none',
    margin: 0
  },
  '&::-webkit-inner-spin-button': {
    '-webkit-appearance': 'none',
    margin: 0
  },
  '&::-webkit-calendar-picker-indicator': {
    '-webkit-appearance': 'none',
    display: 'none'
  },
  'input[type=number]': {
    '-moz-appearance': 'textfield'
  },
  '&:focus': {
    border: `1px solid ${COLORS.MainBlue} !important`
  },
  '&::placeholder': {
    color: '#A18D8E',
    fontSize: '14px',
    fontWeight: '300'
  }
}));

export const StyledImg = styled('img')({
  marginInlineStart: '1.5em'
});

export const ErrorType = styled('p')({
  color: `${COLORS.MainRed}!important`,
  fontSize: '1rem',
  fontWeight: '300'
});

export const Label = styled('label')({
  fontSize: '1.1rem',
  fontWeight: '400',
  marginBottom: '0.5rem'
});

export const SecLabel = styled('p')({
  fontSize: '1rem',
  fontWeight: '300',
  marginBottom: '1rem',
  color: COLORS.MildGray
});

export const ActionContainer = styled('div')({
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  borderRadius: '12px',
  backgroundColor: '#F9F9F9',
  border: '1px solid #E1DBDB',
});

export const Action = styled('div')({
  position: 'absolute',
  right: '1rem',
  top: '0',
  padding: '2px',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
});

export const StyledFormLabel = styled(FormControlLabel)(({ checked }) => ({
  '.MuiFormControlLabel-label': checked
    ? {
        fontWeight: 700
      }
    : {
        color: '#6F6F6F'
      },
  '.MuiSvgIcon-root': checked
    ? {
        color: COLORS.MainBlue
      }
    : {
        color: '#6F6F6F'
      }
}));

export const CustomSelect = styled(Select)({
  width: '100%',
  height: '56px',
  '& .MuiInputBase-input': {
    borderRadius: 4,
    backgroundColor: '#fff',
    // border: '1px solid #dbdce9',
    fontFamily: 'Outfit'
  }
});

export const IconCON = styled('div')({
  padding: '1rem',
  backgroundColor: '#F9F9F9',
  borderRadius: '0 12px 12px 0',
});